import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

const Navigation = () => {
  const [status, setStatus] = useState("top");

  const toggle = () => {
    const navItem = document.getElementsByClassName('navbar-collapse')[0];
    navItem.classList.toggle('active');
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = document.scrollingElement.scrollTop;
      if (scrolled >= 120) {
        if (status !== "not-top") {
          setStatus("not-top");
        }
      } else {
        if (status !== "top") {
          setStatus("top");
        }
      }
    };

    document.addEventListener("scroll", handleScroll);

    const toggleButton = document.getElementsByClassName('navbar-toggler')[0];
    const navItem = document.getElementsByClassName('navbar-collapse')[0];

    if (toggleButton) toggleButton.classList.toggle('active');
    if (navItem) navItem.classList.toggle('active');

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [status]);

  return (
    <nav
      className={
        status === "top"
          ? "navbar navbar-expand-lg navbar-light"
          : "navbar navbar-expand-lg navbar-light bg-light fixed-top scrolled"
      }
    >
      <div className="container-fluid">
        <Link
          className={
            status === "top"
              ? "navbar-brand brand-top"
              : "navbar-brand brand-scrolled"
          }
          to="/"
        >
          gobillion
          <img
            className="logo-nav"
            src={
              status === "top"
                ? "images/logo.svg"
                : "images/orange-logo.svg"
            }
            alt="logo-nav"
          />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggle}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="navbar-collapse" id="navbarResponsive">
          <ul className="navbar-nav ml-auto links">
            {/* <li className="nav-item">
              <a
                className={
                  status === "top"
                    ? "nav-link link-top"
                    : "nav-link link-scrolled"
                }
                href="https://play.google.com/store/apps/details?id=com.gobillion.android.commerce"
                onClick={toggle}
              >
                <span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M5,20H19V18H5M19,9H15L13,7H9V9H15V11H4A2,2 0 0,0 2,13V20A2,2 0 0,0 4,22H20A2,2 0 0,0 22,20V11A2,2 0 0,0 20,9Z" />
                  </svg>
                </span>
                <span> Download App</span>
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a
                className={
                  status === "top"
                    ? "nav-link link-top"
                    : "nav-link link-scrolled"
                }
                href="https://gobillion.wixsite.com/campus"
                onClick={toggle}
              >
                Influencers
              </a>
            </li> */}
            <li className="nav-item">
              <a
                className={
                  status === "top"
                    ? "nav-link link-top"
                    : "nav-link link-scrolled"
                }
                href="#aboutus"
                onClick={toggle}
              >
                About Us
              </a>
            </li>
            <li className="nav-item">
              <a
                className={
                  status === "top"
                    ? "nav-link link-top"
                    : "nav-link link-scrolled"
                }
                href="#explore"
                onClick={toggle}
              >
                Shopping Rooms
              </a>
            </li>
            {/* <li className="nav-item">
              <a
                className={
                  status === "top"
                    ? "nav-link link-top"
                    : "nav-link link-scrolled"
                }
                href="#have-a-query"
                onClick={toggle}
              >
                Contact Us
              </a>
            </li> */}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
